import React, { useMemo, useEffect } from 'react';
import BaseSelect from 'components/molecules/select/base';
import {
  CallTypesEnum,
  getCallTypeLabel,
  type CallType,
  type ICallHistory,
  type ISplitCall,
} from 'infrastructure/hooks/callHistoryManagement/types';

type Option = {
  value: CallType;
  label: string;
};

interface ICallTypeSelectProps {
  label: string;
  editingItem: ICallHistory;
  currentItem: ISplitCall;
  onChange: (val: Option | Option[]) => void;
}

const CallTypeSelect: React.FC<ICallTypeSelectProps> = (props) => {
  const { label, editingItem, currentItem, onChange } = props;

  const options: Option[] = useMemo(() => {
    const filtered = CallTypesEnum.filter((el) =>
      editingItem.patient.guid === currentItem.patientGuid
        ? el !== editingItem.type
        : el,
    );

    return filtered.map((el) => ({
      value: el,
      label: getCallTypeLabel(el),
    }));
  }, [currentItem.patientGuid]);

  const selectedValue = useMemo(() => {
    return options.find((el) => el.value === currentItem.type) || options[0];
  }, [options, currentItem.type]);

  useEffect(() => {
    onChange(selectedValue);
  }, [selectedValue]);

  return (
    <BaseSelect
      label={label}
      allowClear={false}
      value={selectedValue}
      options={options}
      onChange={onChange}
    />
  );
};

export default CallTypeSelect;
